const tabbableSelector =
  'a[href],button:not([disabled]),input:not([disabled]),' +
  'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex^="-"])';

export function getTabbableElements(root: ParentNode): HTMLElement[] {
  return Array.from(
    root.querySelectorAll<HTMLElement>(tabbableSelector),
  ).filter((element) => element.getClientRects().length > 0);
}
